// src/components/BackButton.js
import { useNavigate } from 'react-router-dom';

export default function BackButton({ fallback = '/' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(fallback, { replace: true });
    }
  };

  return (
    <button className="btn btn-secondary backbtn" onClick={handleBack}>
      <img src="/assets/img/left-arrow-wht.png" alt=""/> Back
    </button>
  );
}
